import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../assets/page-image/gpyq/检测仪.png';
const _hoisted_1 = {
  class: "gpyq-wrapper"
};
const _hoisted_2 = {
  class: "gpyq-page"
};
const _hoisted_3 = {
  class: "content-wrapper"
};
const _hoisted_4 = {
  class: "right-content"
};
const _hoisted_5 = {
  class: "section"
};
const _hoisted_6 = {
  class: "section"
};
export default /*@__PURE__*/_defineComponent({
  __name: 'Gpyq',
  setup(__props) {
    // 组件已通过unplugin-vue-components自动注册为全局组件，无需手动导入
    return (_ctx, _cache) => {
      const _component_Breadcrumb = _resolveComponent("Breadcrumb");
      const _component_SideMenu = _resolveComponent("SideMenu");
      const _component_SectionTitle = _resolveComponent("SectionTitle");
      const _component_Footer = _resolveComponent("Footer");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Breadcrumb, {
        items: [{
          label: '首页',
          path: '/'
        }, {
          label: '产品服务'
        }, {
          label: '半导体检测'
        }]
      }), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_SideMenu, {
        activeId: "gpyq"
      }), _createElementVNode("div", _hoisted_4, [_cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "page-title"
      }, "全自动镜片表面表面缺陷检测仪", -1)), _cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "publish-time"
      }, "发布时间：2025年1月1日", -1)), _cache[4] || (_cache[4] = _createElementVNode("div", {
        class: "product-image"
      }, [_createElementVNode("img", {
        src: _imports_0,
        alt: "全自动镜片表面表面缺陷检测仪"
      })], -1)), _createElementVNode("div", _hoisted_5, [_createVNode(_component_SectionTitle, {
        title: "产品介绍"
      }), _cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "intro-content"
      }, [_createElementVNode("p", null, "该产品用于光学镜片和精密结构件表面瑕疵的检测,识别镜头表面的微米级瑕疵并进行统计分类,生成全景瑕疵分布图,实现镜头质量等级鉴定。设备适用于紫外、可见、红外光学元件表面瑕疵的全景观测以及高精度机械零件表面镀层、粗糙度、颜色等质量分析。")], -1))]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_SectionTitle, {
        title: "主要参数"
      }), _cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "params-content"
      }, [_createElementVNode("div", {
        class: "params-title"
      }, "产品特点"), _createElementVNode("div", {
        class: "params-list"
      }, [_createElementVNode("p", null, "用于表面斜率小于 15°的平面或凹面/凸面检测明"), _createElementVNode("p", null, "暗场照明系统设计,可观察到不同种类的瑕疵"), _createElementVNode("p", null, "可分辨2um以上的麻点、脏污、划痕等缺陷"), _createElementVNode("p", null, "全表面图像拼接,提供镜头表面瑕疵全景分布图"), _createElementVNode("p", null, "提供可追溯的数据记录")])], -1))])])])]), _createVNode(_component_Footer)]);
    };
  }
});